<template>
  <div style="height: 100%">
    <fdc-panel
      title="데이터 현황 표시"
      style="height: 100%;"
    >
      <brique-grid
        style="width: 100%; height: 70%;"
        id="dataStatusGrid"
        :brique-grid-columns="columnDefs"
        @grid-ready="onGridReady"
        :default-col-def="defaultColDef"
        :row-selection="rowSelection"
        :row-data="rowData"
        edit-type="fullRow"

        :pagination="true"
        :brique-grid-is-view-pagination="false"
        :brique-grid-is-view-cud-count="true"
        :brique-grid-is-view-total-count="true"
        :brique-grid-is-view-selected-count="true"

        :brique-grid-is-view-header="true"
        :brique-grid-refresh-function="refreshData"
        :brique-grid-is-view-add-row-btn="true"
        :brique-grid-is-view-remove-row-btn="true"
      />
      <hr>
      <monaco-editor
        ref="MonacoEditor"
        :code="comment"
        :automatic-layout="true"
        :read-only="true"
        :theme="'vs-dark'"
        style="height: 25%"
      />
    </fdc-panel>
  </div>
</template>

<script>
import MonacoEditor from '@/views/Fdc/EqpInfo/Components/MonacoEditor.vue'

export default {
  name: 'DataStatusDisplay',
  components: {
    'monaco-editor': MonacoEditor
  },
  methods: {
    async onGridReady (params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi

      await this.refreshData()
    },
    async refreshData () {
      const updateData = (data) => {
        this.rowData = data
        this.gridApi.setRowData(data)
      }

      await fetch('https://www.ag-grid.com/example-assets/olympic-winners.json')
        .then((resp) => resp.json())
        .then((data) => updateData(data.slice(0, 100)))
    }
  },
  data: function () {
    return {
      gridApi: null,
      columnApi: null,
      columnDefs: [
        { field: 'athlete', minWidth: 150, checkboxSelection: true },
        { field: 'age', maxWidth: 90, editable: true },
        { field: 'country', minWidth: 150, editable: true },
        { field: 'year', maxWidth: 90, editable: true },
        { field: 'date', minWidth: 150, editable: true },
        { field: 'sport', minWidth: 150 },
        { field: 'gold' },
        { field: 'silver' },
        { field: 'bronze' },
        { field: 'total' }
      ],
      defaultColDef: {
        // flex: 1,
        minWidth: 100,
        filter: false,
        resizable: true,
        sortable: false
      },
      rowSelection: 'multiple',
      rowData: null,
      comment: [
        '/*',
        ' * 주요 설정 (상세 사용법은 소스 참조)',
        ' * - BRIQUE Grid Component props 설정',
        ' */',
        '` :pagination="true" `\t\t\t\t\t\t\t// pagination panel 활성화',
        '` :brique-grid-is-view-pagination="false" `\t\t// pagination button 비활성화 (pagination 사용 시에만 활성화함)',
        '` :brique-grid-is-view-cud-count="true" `\t\t// 변경(추가, 수정, 삭제) 현황 활성화',
        '` :brique-grid-is-view-total-count="true" `\t\t// 전체 Record 수 활성화',
        '` :brique-grid-is-view-selected-count="true" `\t// 선택된 Record 수 활성화'
      ].join('\n')
    }
  }
}
</script>

<style lang="scss">
  .fdc-panel {
    .panel-body {
      padding: 10px;
    }
  }
</style>
